export default __webpack_public_path__ + "static/media/FullClockAnimated.c58b0b19.gif";